// extracted by mini-css-extract-plugin
export var body = "_lm-8";
export var button = "_lm-0";
export var closeButton = "_lm-5";
export var content = "_lm-3";
export var empty = "_lm-f";
export var grid = "_lm-c";
export var header = "_lm-4";
export var icon = "_lm-1";
export var option = "_lm-d";
export var optionSelected = "_lm-e";
export var overlay = "_lm-2";
export var searchIcon = "_lm-a";
export var searchInput = "_lm-b";
export var searchWrapper = "_lm-9";
export var title = "_lm-6";
export var visuallyHidden = "_lm-7";